import styled from "styled-components";

export const AvatarView = styled.div<{
  $size: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size }px;
  height: ${({ $size }) => $size }px;
  border-radius: ${({ theme }) => theme.border_radius.round }px;
  background-color: ${({ theme }) => theme.colors.selected.default };
  border: 1px solid ${({ theme }) => theme.palette.border };
  overflow: hidden;
  position: relative;

  & > .profile-picture {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    inset: 0;
  }

  & > span {
    min-height: ${({ $size }) => $size - 8 }px;
    font-size: ${({ $size }) => $size - 8 }px;
    line-height: ${({ $size }) => $size - 8 }px;
    font-weight: ${({ theme }) => theme.typography.weight.bold };
    color: ${({ theme }) => theme.colors.text.default };
  }
`;
